export default "__VITE_ASSET__CTQ1DL5W__"